import { lazyRouteComponent } from "@tanstack/react-router";
import { Megaphone, SquarePen, Users } from "lucide-react";

import type { PageDef } from "@/app/registry";

/**
 * Research Analyst tools (the "RA desk" menu): publish a call, my calls with
 * outcomes, clients. The API refuses non-RA users (403), and the pages say so.
 * Open again since the RA platform reopened (V063, 26 Oct 2026).
 */
// The owner is a SEBI-registered RA too (rai.ra_calls.RA_ROLES).
const RA_NAV_ROLES = ["ra", "owner"];

export const pages: PageDef[] = [
  {
    path: "/app/calls/new",
    title: "Publish a call",
    component: lazyRouteComponent(() => import("./ComposePage"), "ComposePage"),
    nav: { label: "Publish a call", icon: SquarePen, group: "Practice", order: 0 },
    roles: RA_NAV_ROLES,
    raOnly: true,
  },
  {
    path: "/app/calls",
    title: "My calls",
    component: lazyRouteComponent(() => import("./MyCallsPage"), "MyCallsPage"),
    nav: { label: "My calls", icon: Megaphone, group: "Practice", order: 10 },
    roles: RA_NAV_ROLES,
    raOnly: true,
  },
  {
    path: "/app/calls/clients",
    title: "Clients",
    component: lazyRouteComponent(() => import("./ClientsPage"), "ClientsPage"),
    nav: { label: "Clients", icon: Users, group: "Practice", order: 20 },
    roles: RA_NAV_ROLES,
    raOnly: true,
  },
];
